import axios from 'axios'
import config from '../config/dev.json'
import { refresh } from './auth.service.js'

let path = '/api/v1'
let url = config.host + path + '/secure/expression'
let urlUp = config.host + path + '/file'
import Vue from 'vue'
import production from '../config/production.json'
if(process.env.NODE_ENV === 'production'){
  url = production.host + path + '/secure/expression'
}

export async function getExpressionById(id){
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/'+ id).then((response) => {
      let expression = response.data.data
      resolve(expression)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getExpressionById(id))
        }).catch(err => reject(err))
      }
    })
  })
}
export async function getAllExpressionByIntents(id){
  return new Promise((resolve, reject) => {
    axios.get(url +'/intent/'+ id +'/all').then((response) => {
      let listExpression = response.data.data
      resolve(listExpression)
    }).catch(err =>{
    if(err.response.status === 401){
      refresh().then(() => {
        resolve(getAllExpressionByIntents())
      }).catch(err => reject(err))
    }
  })
})
}
export async function getAllExpressionBybot(id){
  return new Promise((resolve, reject) => {
    axios.get(url +'/intentBot/'+ id +'/all').then((response) => {
      let listExpression = response.data.data

      resolve(listExpression)
    }).catch(err =>{
    if(err.response.status === 401){
      refresh().then(() => {
        resolve(getAllExpressionBybot())
      }).catch(err => reject(err))
    }
  })
})
}
export async function getAllExpression(){
  return new Promise((resolve, reject) => {
    axios.get(url + '/all').then((response) => {
      let expressions = response.data.data
      console.log("teeeeeeeeeest", expressions)
      resolve(expressions)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getAllExpression())
        }).catch(err => reject(err))
      }
    })
  })
}


export async function addExpression(expression){
  console.log("test add new exp", expression)
  return new Promise((resolve, reject) => {
    axios.post(url + '/add', expression).then((response) => {
      let newExpression = response.data.data
      console.log('testadd new ecpr', newExpression)
      resolve(newExpression)
    }).catch(err => reject(err))
  })
}


export async function removeUtterance(intent){
  return new Promise((resolve, reject) => {
   
    console.log("############# service utterance",intent)
   // if (intent._id) {
      axios.post(url + '/remove/expression', intent).then((response) => {
        console.log("########### resultat service",response.data.data )
        resolve(response.data.data)
      }).catch(err => reject(err))
    
  })
  
}

export async function updateUtterance(express){
  return new Promise((resolve, rejetc) => {
    let obj = {
      intent:{ 
        _id: '',
        name: ''
      },
      _id: '',
      source: '',
      language:{
        isocode: '',
        _id: ''
      }
    }
    obj.intent = express.intent
    obj.source = express.utt.source
    obj.language = express.utt.language
    obj._id = express.utt._id
    let id = obj._id
    axios.put(url +'/update/'+ id, obj).then((response) => {
      let expression = response.data.data
      resolve(expression)
    }).catch(err => rejetc(err))
  })
}

export async function AddListUtterance( utrs) {
  return new Promise((resolve, reject) => {
    console.log('test service utterances', utrs)
    axios.post(url + '/add/list', utrs).then((response) => {
      console.log("test response.data.data",response)
      let utrsExp = response.data.data
    
       resolve(utrsExp)
      

    }).catch(err => reject(err))
  })
}

export async function uploadFileExcelExpression(formData, id,intentId,intentName){
  return new Promise((resolve, reject) => {
   console.log("************** urlUp",urlUp + '/upload/'+id+'/expression/'+intentId+'/'+intentName+'/')
    axios.post(urlUp + '/upload/'+id+'/expression/'+intentId+'/'+intentName , formData,
    {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
     
      console.log('tetst res', response.data.data)
    //  location.reload()
      
      
      let propsData = {
        direction: "right",
        duration: 1500
      }
      if (response.data.data==="files printed successfully"){
        Vue.prototype.$notif.show(
          (propsData = {
            
             title: "Success",
             message: response.data.data,
             type: "success"
          })
        );
      }else{
        Vue.prototype.$notif.show(
          (propsData = {
            title: "Error !",
            message:response.data.data ,
            type: "danger"
          })
        );
      }
     
    
          resolve(response.data.data)
    })
    .catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err' , err)
      Vue.prototype.$notif.show(
            (propsData = {
              title: "Error !",
              message: "Check your list expression Maybe this expression exist  !",
              type: "danger"
            })
          );
       
    })
  })
}





// WEBPACK FOOTER //
// ./src/api/expression.service.js